import { AccountInfo } from 'src/api/@generated/backend';

import { api } from 'src/api';
import { selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { createAppAsyncThunk } from 'src/state/thunk-api';
import { handleError } from 'src/utils/error-utils';

export const fetchAccountInfoActionCreator = createAppAsyncThunk<AccountInfo>(
  'request/fetchAccountInfo',
  async (_, { getState }) => {
    const selectedAccount = selectSelectedAccountOrThrow(getState());

    try {
      return await api.accountController.getAccountInfo({
        billingAccountId: selectedAccount.customerId,
        partnerId: selectedAccount.partnerId,
      });
    } catch (error) {
      handleError(error);
      return Promise.reject();
    }
  },
);
